export default {
    profileId(state) {
      return state.authenticated_profile.profileId;
    },
    token(state) {
      return state.authenticated_profile ? state.authenticated_profile.token : null;
    },
    didAutoLogout(state) {
      return state.did_auto_logout;
    },
    isAuthenticated(state){
      return !!state.authenticated_profile;
    },
    logged(state){
      return state.logged;
    },
    try_login_one_time(state){
      return state.try_login_one_time;
    },
    cant_action(state){
      return state.cant_action;
    },
    openEditImgs(state){
      return state.openEditImgs;
    },
    main_loader(state){
      return state.main_loader;
    },
    profileCan(state, intention, resource) {
      if( !state.getters.isAuthenticated )
        return false;
      console.log(intention,resource);
      return true;
    },

    /* Loading */
    getLoadingData(state){
      return state.loading_data
    },

    fake_experiences(state){
      let temp = state.fake_experiences
      return temp ? temp : []
    },

  };